import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(3),
    borderRadius: 10
  },
  label: {
    fontSize: '0.95rem',
    marginBottom: theme.spacing(2)
  },
  confirmButton: {
    marginBottom: theme.spacing(2)
  },
  textArea: {
    marginBottom: theme.spacing(2)
  },
  rejectButton: {}
}))

export default useStyles
